import { Component, OnInit, Input } from '@angular/core';
import { LocalStorageService } from "angular-2-local-storage";
import { AppService } from "../../utils/app.service";
import { StateService } from '@uirouter/angular';
@Component({
    selector: 'ss-connect',
    template: require('./connect.html'),
})

export class ConnectComponent implements OnInit {
    _window: any;
    @Input() params: any;

    constructor(
        private app: AppService,
        private localStorageService: LocalStorageService,
        private stateService: StateService
    ) { }

    ngOnInit() {
        this.app.linkSSToBusiness({
            code: decodeURIComponent(this.params.code),
            state: decodeURIComponent(this.params.state)
        })
    };
}
